import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MailIcon, MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from './Button';
import { navLinks, contactEmail } from '../data/navigation';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <>
      <div className="hidden bg-navy md:block" data-id="element-176" data-mp="2wk72ahfxx5rj">
        <div className="mx-auto flex h-10 max-w-7xl items-center justify-between px-6 text-xs text-white/70 lg:px-10" data-id="element-177" data-mp="2wivywiqeq00y">
          <p data-id="element-178" data-mp="36as7inq4d8jf">Executive Search · Senior Recruitment · Talent Sourcing</p>
          <a href={`mailto:${contactEmail}`} className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-gold" data-id="element-179" data-mp="36d4r15bizqyl">
            <MailIcon size={14} strokeWidth={1.5} aria-hidden="true" data-id="element-180" data-mp="3fbzu48j9wkxo" />
            {contactEmail}
          </a>
        </div>
      </div>

      <header className="sticky top-0 z-50 border-b border-ink/10 bg-white/95 backdrop-blur" data-id="element-181" data-mp="2rlrixdylnl0f">
        <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-6 lg:px-10" data-id="element-182" data-mp="2mmoo0mcc2v66">
          <Logo data-id="element-183" data-mp="2hnlk5583auzs" />

          <nav aria-label="Primary" className="hidden xl:block" data-id="element-184" data-mp="2ho3pcrcqcjju">
            <ul className="flex items-center gap-7" data-id="element-185" data-mp="2hpy9w4k3a9ne">
              {navLinks.map(link => <li key={link.to} data-id="element-186" data-mp="3fd6p5hthymgy">
                  <NavLink to={link.to} end={link.to === '/'} className={({
                isActive
              }) => `whitespace-nowrap border-b pb-1 text-[14px] font-medium transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:text-navy ${isActive ? 'border-gold text-navy' : 'border-transparent text-ink/75 hover:text-navy'}`} data-id="element-187" data-mp="3abps5xe4vk5n">
                    {link.label}
                  </NavLink>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-3" data-id="element-188" data-mp="1ho1hr2k2780f">
            <Button to="/employers" size="sm" className="hidden sm:inline-flex" data-id="element-189" data-mp="1hn8i0ljipirs">
              Hire Talent With Us
            </Button>
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-10 w-10 items-center justify-center rounded-sm text-navy transition-colors duration-150 ease-out hover:bg-mist focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold xl:hidden" data-id="element-190" data-mp="18n3bseq28qf7">
              {open ? <XIcon size={22} strokeWidth={1.5} data-id="element-191" data-mp="2t140a35py7n8" /> : <MenuIcon size={22} strokeWidth={1.5} data-id="element-192" data-mp="2y29vc7muq6zx" />}
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-193" data-mp="mfptuac7twl3">
          {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
          opacity: 0,
          y: -8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} className="border-t border-ink/10 bg-white xl:hidden" data-id="element-194" data-mp="mcbqozvq9jcl">
              <ul className="mx-auto max-w-7xl px-6 py-4" data-id="element-195" data-mp="153l3bi0soo8e">
                {navLinks.map(link => <li key={link.to} data-id="element-196" data-mp="105tbeo05h247">
                    <NavLink to={link.to} end={link.to === '/'} className={({
                isActive
              }) => `flex items-center justify-between border-b border-ink/5 py-3.5 font-serif text-xl font-medium ${isActive ? 'text-navy' : 'text-navy/80'}`} data-id="element-197" data-mp="1f325vqkr2m05">
                      {({
                  isActive
                }) => <>
                          {link.label}
                          {isActive && <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden="true" data-id="element-198" data-mp="27w70eo64dc7a" />}
                        </>}
                    </NavLink>
                  </li>)}
                <li className="pt-5 sm:hidden" data-id="element-199" data-mp="2gxn9msl7789x">
                  <Button to="/employers" className="w-full" data-id="element-200" data-mp="1k8pe385mj6bp">
                    Hire Talent With Us
                  </Button>
                </li>
                <li className="pt-4 text-sm text-ink/70 md:hidden" data-id="element-201" data-mp="1p7imwn9yu95j">
                  <a href={`mailto:${contactEmail}`} className="underline decoration-gold underline-offset-4" data-id="element-202" data-mp="1t7sxyecm7pr9">
                    {contactEmail}
                  </a>
                </li>
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </header>
    </>;
}